import React, { useEffect, useState } from 'react'
import CartItems from '../Cart/CartItems'
import { connect, useSelector } from 'react-redux';
import { favoritesList, deletefavourites } from '../../Redux/actions/customer';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import MenuCard from './MenuCard';
import Header from '../../Components/Header';
import Modal from 'react-bootstrap/Modal';
import MenuBox from '../Menu/MenuBox';
import ComboMenuBox from '../Menu/ComboMenuBox';
import { priceunit } from '../../Components/client-config';
import { getComboDetail, getItemDetail } from '../../Redux';
import GoBack from '../BackButton/GoBack';
import JazzCashOnly from '../../Components/JazzCashOnly';
import useCurrentLocale from '../../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import Footer from '../../Components/Footer';

function AddFavourite(props: any) {
  const history = useHistory();
  const favItems = useSelector((state: any) => state.customer.favItemData);
  const isLogged = useSelector((state: any) => state.customer.isLogged);
  const comboData = useSelector((state: any) => state.menu.comboData);
  const itemData = useSelector((state: any) => state.menu.itemData);
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [comboOpen, setComboOpen] = useState(false);
  const [selectStoreShow, setSelectStoreModal] = useState(false);
  const handleSelectStoreClose = () => setSelectStoreModal(false);
  const handleComboClose = () => setComboOpen(false);
  const handleComboOpen = () => setComboOpen(true);
  const handleClose = () => setShow(false);
  const orderType = useSelector((state: any) => state.payment.orderType);
  const [selectJCShow, setSelectJCModal] = useState(false);
  const [ModalType, setModalType] = useState('');
  const lang = useCurrentLocale();


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!isLogged) {
      toast.error(t("PLEASE_LOGIN_FIRST_TO_VIEW_FAVOURITE_LIST"));
      history.push(`/${lang}/menu`);
    } else {
      props.favoritesList()
    }
  }, [])

  const handleSelectJSToogle = () => {
    if(ModalType === 'item' && itemData.item_size && itemData.item_size[0].is_jazz_cash === 1)
    {
      setSelectJCModal((prev)=> {
        return !prev
      })
    }
    if(ModalType === 'combo' && comboData && comboData.is_jazz_cash && comboData.is_jazz_cash == 1)
    {
      setSelectJCModal((prev)=> {
        return!prev
      })
    }
  }

  const CloseCompoment = () => {
    handleClose()
    handleComboClose()
    if (window.location.hash) {
      window.history.replaceState("", document.title, window.location.pathname);
    }
  }

  const selectedItem = (item: any) => {
    
    if (item.menu_item_id && item.menu_item_id > 0) {
      props.getItemDetail(orderType, item.menu_item_id, handleShow)
    }
    if (item.combo_id && item.combo_id > 0) {
      props.getComboDetail(orderType, item.combo_id, handleComboOpen)
    }
    let products: any = []
    let MapObj: any = {}

    if (item.menu_item_id && item.menu_item_id > 0) {
      MapObj = {
        price: item.item_size && priceunit + item.item_size[0].mrp,
        id: item.menu_item_id,
        name: item.item_name,

      }
    }
    else if (item.combo_id && item.combo_id > 0) {
      MapObj = {
        price: item.combo_mrp_price,
        id: item.combo_id,
        name: item.item_name,
      }
    }
    products.push(MapObj)
  }
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className='container mb-5 mt-120'>
        <div className='d-flex align-items-center gap-10 mb-3 web-backbtn'>
          <GoBack/>
          <h2 className='items-title mb-0 mt-0'><span>{t("FAVOURITE_ITEMS")}</span></h2>
        </div>
        {
          favItems.length > 0 ?
            <div className="row">
              {
                favItems?.map((item: any) => 
                  <div className='col-lg-3 col-md-4 col-6'>
                    {<MenuCard item={item} actions={props} handleShow={handleShow} selectedItem={selectedItem}/>}
                    
                  </div>
                )
              }


            </div> :
            <h2 className='note-found-data'>
              {t("NOT_FOUND")}
            </h2>
        }
      </div>
      
       {show &&
        <Modal show={show} onHide={CloseCompoment} backdrop="static" keyboard={false} size="lg" centered>
          <div className='modal-design'>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <Modal.Header className='p-0 border-0' closeButton />
          <MenuBox handleClose={CloseCompoment} setSelectStoreModal={setSelectStoreModal} handleToogle={handleSelectJSToogle} /> 
        </Modal>
      }
      {comboOpen &&
        <Modal show={comboOpen} onHide={CloseCompoment} backdrop="static" keyboard={false} size="lg" centered>
          <div className='modal-design'>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <Modal.Header className='p-0 border-0' closeButton />
          <ComboMenuBox handleClose={CloseCompoment} setSelectStoreModal={setSelectStoreModal} handleToogle={handleSelectJSToogle}  />
        </Modal>
      }
      <JazzCashOnly show={selectJCShow} handleToogle={handleSelectJSToogle} />
      <Footer />
    </>
  )
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    favoritesList: function () {
      dispatch(favoritesList());
    },
    deletefavourites: function (id: any,data:any) {
      dispatch(deletefavourites(id,data));
    },
    getItemDetail: (orderType: any, id: any, handleShow:any) => {
      dispatch(getItemDetail(orderType, id, handleShow))
    },
    getComboDetail: (orderType: any, id: any, handleComboOpen:any) => {
      dispatch(getComboDetail(orderType, id, handleComboOpen))
    },


  }
}
export default connect(null, mapDispatchToProps)(AddFavourite);
